import { playerViewsInitialState } from '../../client/initialStates';
import { playerViewFetchSuccessAction } from './actions';
import { createReducer } from '@reduxjs/toolkit';

export const playerViewFetchSuccessReducer = createReducer(
  playerViewsInitialState,
  builder =>
    builder.addCase(
      playerViewFetchSuccessAction,
      (state, { payload: response }) => {
        const newState = { ...state };

        const { viewId, view } = response;
        newState[viewId] = view;

        return newState;
      }
    )
);
